var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("span", { staticClass: "text-no-wrap" }, [
    _c("img", {
      staticClass: "mx-2",
      staticStyle: {
        width: "24px",
        display: "inline",
        "vertical-align": "middle"
      },
      attrs: {
        src: require("@/assets/images/deviceTypes/microsoft.svg"),
        alt: "windows logo"
      }
    }),
    _c("span", { staticClass: "font-weight-medium font-italic text-h6" }, [
      _vm._v(" (" + _vm._s(_vm.$t("policiesGroups.winOnly")) + ") ")
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }